import moment from 'moment'

export const defaultTableSorter = (headers, column, descending) => {
  return (items) => {
    let header = headers.find(h => h.value == column)
    if (!header) return items
    let sorter = header.sorter

    let result
    if (!sorter) result = items.slice().sort()
    else result = items.slice().sort(sorter)

    if (descending) result = result.reverse()
    return result
  }
}

export const objectSorter = (key, sorter, mapper) => (a, b) => {
  if (mapper) return sorter(mapper[a[key]], mapper[b[key]])
  else return sorter(a[key], b[key])
}

export const stringSorter = (a, b) => {
  const normalizedA = '' + (a && a.toLowerCase())
  const normalizedB = '' + (b && b.toLowerCase())
  return normalizedA.localeCompare(normalizedB)
}

export const datetimeSorter = (a, b) => {
  return moment.utc(a).diff(moment.utc(b))
}

export const numberSorter = (a, b) => {
  return parseFloat(a) - parseFloat(b)
}

export function sortObject(prop) {
  return function(a, b) {
    let v1 = a[prop].toUpperCase()
    let v2 = b[prop].toUpperCase()
    if (v1 < v2) {
      return -1
    }
    if (v1 > v2) {
      return 1
    }
    return 0
  }
}

export function sortId(id) {
  return (a, b) => {
    var value1 = a[id]
    var value2 = b[id]
    return value1 - value2
  }
}